import React from "react";
import { connect } from "react-redux";
import { Snackbar } from "material-ui";
import ReactJson from "react-json-view";
import { ErrorSnackClose } from "./actions";

const isJSON = require("is-valid-json");

class ErrorSnack extends React.Component {
  handleErrorSnackClose = () => {
    this.props.dispatch(ErrorSnackClose());
  }

  render() {
    const errorObject = (isJSON(this.props.errorObject) ?
      (<ReactJson
        theme="monokai"
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        indentWidth={1}
        name={false}
        shouldCollapse={false}
        enableClipboard={false}
        displayObjectSize={false}
        displayDataTypes={false}
        src={this.props.errorObject}
      />) :
      <p><strong>{this.props.errorObject}</strong></p>);

    return (
      <div>
        <Snackbar
          open={this.props.open}
          message={
            <div>
              {this.props.mensaje}
              {errorObject}
            </div>}
          action="cerrar"
          // autoHideDuration={this.props.autoHideDuration}
          onRequestClose={this.handleErrorSnackClose}
          onActionClick={this.handleErrorSnackClose}
          bodyStyle={{
            height: "auto", lineHeight: "28px", padding: 24, whiteSpace: "pre-line",
          }}
        >
          <p>Hola</p>

        </Snackbar>
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  mensaje: state.errorSnack.mensaje,
  open: state.errorSnack.open,
  autoHideDuration: state.errorSnack.autoHideDuration,
  errorObject: state.errorSnack.errorObject,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(ErrorSnack);



// WEBPACK FOOTER //
// ./src/components/ErrorSnack/view.jsx